import { render } from "./MMyWallet.vue?vue&type=template&id=2d839e2c&scoped=true"
import script from "./MMyWallet.vue?vue&type=script&lang=js"
export * from "./MMyWallet.vue?vue&type=script&lang=js"

import "./MMyWallet.vue?vue&type=style&index=0&id=2d839e2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d839e2c"]])

export default __exports__